export const searchTermsToRoutes: { [key: string]: string } = {
  blank: 'blank',
  'blank template': 'blank',
  'blank templates': 'blank',
  blog: 'blog',
  education: 'community-education/education',
  travel: 'travel-tourism',
  'landing page': 'landing-pages',
  art: 'creative-arts',
  video: 'video',
  portfolio: 'portfolio-cv/portfolios',
  music: 'music',
  fashion: 'fashion-and-style/fashion',
  business: 'business',
  beauty: 'beauty-and-hair',
  photography: 'photography',
  health: 'health-wellness/health',
  landing: 'landing-pages',
  event: 'events',
  'online store': 'online-store',
  events: 'events',
  store: 'online-store',
  design: 'design',
  shop: 'online-store',
  community: 'community-education/community',
  resume: 'portfolio-cv/resumes-cvs',
  cv: 'portfolio-cv/resumes-cvs',
  restaurant: 'restaurants-food/restaurant',
  designer: 'design/designer',
  'landing pages': 'landing-pages',
  wedding: 'events/weddings',
  'real estate': 'business/real-estate',
  'car business': 'business/automotive-cars',
  'coming soon': 'landing-pages/coming-soon',
};
